import axios from 'axios'
import { v4 as uuid } from 'uuid'

import { Address } from '../models/address.model'

export default class AddressService {
  constructor(private apiGateway: string) {}
  // @TODO: use param when we have real service
  fetchStreets(input: string): Promise<Address[]> {
    return axios
      .get(`${this.apiGateway}/addresses/v1/masmovil/horizontal-addresses`, {
        params: {
          channel: 'mysim',
          segment: 'res',
          checkId: uuid(),
          search: input,
        },
      })
      .then((res) => res.data)
  }
}
